// One price style everywhere: small raised ₹, Switzer tabular lining numerals, medium, deep marine; en-IN grouping (₹1,599).
const SIZES = { card: "text-[19px]", detail: "text-[23px]", row: "text-[18px]", total: "text-[24px] font-normal", grand: "text-[32px] font-normal" };

export const Price = ({ value, size = "card", testId, className = "" }) => (value == null ? (
  <span data-testid={testId} data-por="1" className={`font-ui whitespace-nowrap text-[15px] italic text-[#33566B] ${className}`}>Price on request</span>
) : (
  <span data-testid={testId} className={`price font-ui whitespace-nowrap font-normal text-[#0B2E44] ${SIZES[size]} ${className}`}>
    <span aria-hidden className="price-rupee">₹</span>
    <span className="sr-only">₹</span>
    {Number(value).toLocaleString("en-IN")}
  </span>
));

// "+ price on request" note under a total when any item has no price yet.
export const PorNote = ({ names, testId, className = "" }) => (names?.length ? (
  <span data-testid={testId} className={`font-ui block text-[14px] italic text-[#33566B] ${className}`}>+ {names.join(", ")}: price on request</span>
) : null);

const SERVE = (s) => (s === "ROOM TEMP" ? "Room temp" : s[0] + s.slice(1).toLowerCase());

// Drink serves: "HOT ₹355 | ICED ₹365"; single serve shows its label with the one price. Optional onSelect makes each serve tappable.
export const ServePrices = ({ dish, size = "card", testId, selected, onSelect }) => {
  const serves = dish.serves?.length ? dish.serves : null;
  if (!serves) return <Price value={dish.price_inr} size={size} testId={testId} />;
  return (
    <span data-testid={testId} className="inline-flex flex-wrap items-baseline gap-x-3 gap-y-1">
      {serves.map((s, i) => {
        const body = (
          <>
            <span className="font-ui mr-1.5 text-[14px] font-normal uppercase tracking-[0.14em] text-[#33566B]">{SERVE(s.serve)}</span>
            <Price value={s.price_inr} size={size} />
          </>
        );
        return (
          <span key={s.serve} className="inline-flex items-baseline">
            {i > 0 && <span aria-hidden className="mr-3 h-4 w-px self-center bg-[#0B2E44]/25" />}
            {onSelect ? (
              <button type="button" data-testid={`${testId}-${s.serve.toLowerCase().replace(/\s/g, "-")}`} aria-pressed={selected === s.serve}
                onClick={(e) => { e.stopPropagation(); onSelect(s.serve); }}
                className={`inline-flex min-h-[48px] items-baseline rounded-full px-3 pt-3 ${selected === s.serve ? "ring-1 ring-[#E8508A]" : "ring-1 ring-[#0B2E44]/15"}`}>{body}</button>
            ) : body}
          </span>
        );
      })}
    </span>
  );
};
